import { render } from "./groupItem.vue?vue&type=template&id=3ff394aa&scoped=true"
import script from "./groupItem.vue?vue&type=script&lang=js"
export * from "./groupItem.vue?vue&type=script&lang=js"

import "./groupItem.vue?vue&type=style&index=0&id=3ff394aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff394aa"]])

export default __exports__